import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import type { FoodCategory } from './types';

const QUERY_KEY = ['food-categories'] as const;

export function useFoodCategories() {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: async (): Promise<FoodCategory[]> => {
      const { data, error } = await supabase
        .from('food_categories')
        .select('*')
        .order('sort_order', { ascending: true })
        .order('label', { ascending: true });
      if (error) throw error;
      return (data ?? []) as FoodCategory[];
    },
  });
}
